// @ts-nocheck
import {useCustomGoogleAnalytics} from '~/composables/useCustomGAScript'

class AnalyticsManager {

  baseUrl = null;
  klaviyoDelay = 500;
  $ga = null;
  $fb = null;
  $klaviyo = null;
  googleAdsConversionSendTo = null;

  init(site) {
      const currentUrl = useRequestURL();
      this.baseUrl =  currentUrl.origin;

      if (site?.data?.googleAnalyticsId) {
        const {proxy: $ga} = useCustomGoogleAnalytics({
          id: site?.data?.googleAnalyticsId,
          // Disable auto page_view when GTM is also configured to prevent duplicate tracking
          sendPageView: !site?.data?.googleGtmId,
        })
        this.$ga = $ga
      }
    if (site?.data?.facebookAnalyticsId) {
      const {proxy: $fb} = useScriptMetaPixel({
        id: site?.data?.facebookAnalyticsId
      })
      this.$fb = $fb
    }
    //klaviyo
    const root = this;
    setTimeout(function() {
      if (typeof klaviyo !== 'undefined') {
        root.$klaviyo = klaviyo;
      }
    }, 300)

  }

  trackProduct(product) {
    const root = this;
    if (root.$ga) {
      root.$ga.gtag('event', 'view_item', {
        items: [
          {
            item_id: product.id,
            item_name: product.title,
          }
        ],
      })
    }
    if (root.$fb) {
      root.$fb.fbq('track', 'ViewContent', {
        content_ids: [product.id],
        content_type: 'product',
      })
    }
    setTimeout(function() {
      if (root.$klaviyo) {
        root.$klaviyo.track('Viewed Product', {
          "ProductName": product.title,
          "ProductID": product.id,
          "ImageURL": product.image,
          "URL": `${root.baseUrl}/${product.url}`,
        });
      }
    }, root.klaviyoDelay)

  }

  trackAddToCart(cart, currency) {
    const lastItem = cart.items[cart.items.length - 1];
    if (this.$ga) {
      this.$ga.gtag('event', 'add_to_cart', {
        currency: currency,
        value: lastItem.variations.reduce((acc, item) => acc + item.price * item.quantity, 0),
        items: lastItem.variations.map(item => {
          return {
            item_id: lastItem.productId,
            item_name: lastItem.productTitle,
            item_category: lastItem.type,
            price: item.price,
            quantity: item.quantity,
          }
        }),
      })
    }
    if (this.$fb) {
      this.$fb.fbq('track', 'AddToCart', {
        contents: lastItem.variations.map(item => {
          return {
            id: lastItem.productId,
            quantity: item.quantity,
          }
        }),
        content_type: 'product',
        value: lastItem.variations.reduce((acc, item) => acc + item.price * item.quantity, 0),
        currency: currency,
      })
    }

    if (this.$klaviyo) {
      this.$klaviyo.track("Added to Cart", {
        "$value": cart.total,
        "Currency": currency,
        "AddedItemProductName": lastItem.productTitle,
        "AddedItemProductID": lastItem.productId,
        "AddedItemImageURL": lastItem.image,
        "AddedItemURL": lastItem.url,
        "AddedItemPrice": lastItem.variations[lastItem.variations.length - 1].price,
        "AddedItemQuantity": lastItem.variations[lastItem.variations.length - 1].quantity,
        "ItemNames": cart.items.map(item => item.productTitle),
        "CheckoutURL": `${this.baseUrl}/checkout`,
        "Items": cart.items.flatMap(item => item.variations.map(variation => ({
              "ProductID": item.productId,
              "ProductName": item.productTitle,
              "Quantity": variation.quantity,
              "ItemPrice": variation.price,
              "RowTotal": variation.price * variation.quantity,
              "ProductURL": `${this.baseUrl}/${item.url}`,
              "ImageURL": item.image,
            }))
        ),
      });
    }
  }

  trackPageView(path) {
    if (this.$ga) {
      this.$ga.gtag('event', 'page_view', {
        page_location: this.baseUrl + path,
        page_path: path,
      })
    }
    if (this.$fb) {
      this.$fb.fbq('track', 'PageView')
    }
  }

  trackSearch(searchTerm) {
    if (this.$ga) {
      this.$ga.gtag('event', 'search', {
        search_term: searchTerm,
      })
    }
    if (this.$fb) {
      this.$fb.fbq('track', 'Search', {
        search_string: searchTerm
      })
    }
  }

  trackAddToWishlist(id, type) {
    if (this.$ga) {
      this.$ga.gtag('event', 'add_to_wishlist', {
        items: [
          {
            item_id: id,
          }
        ]
      })
    }
    if (this.$fb) {
      this.$fb.fbq('track', 'AddToWishlist', {
        content_ids: [id],
        content_type: type
      })
    }
  }

  trackInitiateCheckout(cart, currency) {
    if (this.$ga) {
      this.$ga.gtag('event', 'begin_checkout', {
        items: cart.items.flatMap(item => item.variations.map(variation => ({
          item_id: item.productId,
          item_name: item.productTitle,
          item_category: item.type,
          price: variation.price,
          quantity: variation.quantity,
        }))),
        currency: currency,
        value: cart.total
      })
    }
    if (this.$fb) {
      this.$fb.fbq('track', 'InitiateCheckout', {
        content: cart.items.flatMap(item => item.variations.map(variation => ({
          id: item.productId,
          quantity: variation.quantity,
        }))),
        content_type: 'product',
        value: cart.total,
        currency: currency
      })
    }

    if (this.$klaviyo) {
      this.$klaviyo.track("Started Checkout", {
        "$value": cart.total,
        "Currency": currency,
        "ItemNames": cart.items.map(item => item.productTitle),
        "CheckoutURL": `${this.baseUrl}/checkout`,
        "Items": cart.items.flatMap(item => item.variations.map(variation => ({
              "ProductID": item.productId,
              "ProductName": item.productTitle,
              "Quantity": variation.quantity,
              "ItemPrice": variation.price,
              "RowTotal": variation.price * variation.quantity,
              "ProductURL": `${this.baseUrl}/${item.url}`,
              "ImageURL": item.image,
            }))
        ),
      });
    }

  }

  trackAddPaymentMethod(firstName, lastName, email) {
    if (this.$ga) {
      this.$ga.gtag('event', 'add_payment_info', {
        user_first_name: firstName,
        user_last_name: lastName,
        user_email: email
      })
    }
    if (this.$fb) {
      this.$fb.fbq('track', 'AddPaymentInfo', {
        user_first_name: firstName,
        user_last_name: lastName,
        user_email: email
      })
    }
  }

  trackPurchase(orderId, firstName, lastName, email, items, currency, value, coupon = null, discount = 0) {
    if (this.$ga) {
      this.$ga.gtag('event', 'purchase', {
        transaction_id: orderId,
        value: value,
        currency: currency,
        items: items,
        coupon: coupon,
        discount: discount,
        user_first_name: firstName,
        user_last_name: lastName,
        user_email: email
      })

      if (this.googleAdsConversionSendTo) {
        this.$ga.gtag('event', 'conversion', {
          send_to: this.googleAdsConversionSendTo,
          transaction_id: orderId,
          value: value,
          currency: currency,
        })
      }
    }
    if (this.$fb) {
      this.$fb.fbq('track', 'Purchase', {
        order_id: orderId,
        contents: items.map((item) => {
          return {
            id: item.item_id,
            quantity: item.quantity,
          }
        }),
        coupon: coupon,
        content_type: 'product',
        value: value,
        currency: currency,
        user_first_name: firstName,
        user_last_name: lastName,
        user_email: email
      })
    }
  }
}

export default defineNuxtPlugin(nuxtApp => {
  const analyticsManager = new AnalyticsManager()
  const config = useRuntimeConfig()
  analyticsManager.googleAdsConversionSendTo = config.public.googleAdsConversionSendTo || null

  nuxtApp.hook('app:beforeMount', async () => {
    const siteStore = useSiteStore();
    await siteStore.fetch()
    analyticsManager.init(siteStore);

    // Track page_view on every SPA navigation after the initial mount.
    // The initial page_view is already handled by clientInit (when no GTM) or by GTM itself.
    const router = useRouter()
    router.afterEach((to) => {
      analyticsManager.trackPageView(to.fullPath)
    })
  });
  return {
    provide: {
      analyticsManager: analyticsManager
    }
  }
})
